import { useLocation, useNavigate, useParams as useRouterParams } from 'react-router-dom';

export function useRouter() {
  const navigate = useNavigate();
  return {
    push: (href: string) => navigate(href),
    replace: (href: string) => navigate(href, { replace: true }),
    back: () => navigate(-1),
    forward: () => navigate(1),
    refresh: () => window.location.reload(),
    prefetch: async (_href: string) => undefined,
  };
}

export function usePathname() { return useLocation().pathname; }
export function useSearchParams() { return new URLSearchParams(useLocation().search); }
export function useParams<T extends Record<string, string | string[] | undefined> = Record<string, string>>() { return useRouterParams() as T; }
export function redirect(href: string): never { window.location.replace(href); throw new Error(`Redirecting to ${href}`); }
export function notFound(): never { throw new Response('Not found', { status: 404 }); }
